import React, { useContext, useState, useEffect } from "react";
import "../../../styles/Header.css";
import apiRoot from "../../../api/apiRoot";
import { useParams, Link } from "react-router-dom";
import { ClientContext } from "../../../contexts/ClientContext";
import { DEFAULT_STATE } from "../../../helper/defaultState";
import { useMsal } from "@azure/msal-react";

const ColorAppHeader = ({ paletteName, colorRows, currentClient }) => {
  const { clientid } = useParams();
  const { updateCurrentSet } = useContext(ClientContext);
  const { accounts } = useMsal();

  const [exportingFigma, setExportingFigma] = useState(false);
  const [exportFigmaStatus, setExportFigmaStatus] = useState("Export To Figma");
  const [exportingCSS, setExportingCSS] = useState(false);
  const [exportCSSStatus, setExportCSSStatus] = useState("Export To CSS");

  const handleFigmaExport = async (e) => {
    setExportingFigma(true);
    e.preventDefault();
    let responseStatus;
    try {
      const response = await apiRoot.post("/exportToFigma", {
        colorRows: colorRows,
        paletteName: paletteName,
      });
      responseStatus = "Success!";
    } catch {
      responseStatus = "Failed!";
    }
    setExportingFigma(false);
    setExportFigmaStatus(responseStatus);
  };

  const handleCSSExport = async (e) => {
    setExportingCSS(true);
    e.preventDefault();
    let responseStatus;
    try {
      const response = await apiRoot.post("/exportToCSS", {
        colorRows: colorRows,
        setName: paletteName.split("-")[1].toLowerCase(),
        clientName: currentClient.tealium_profile_code,
        email: accounts[0].username || "blake.brown@marketviewedu.com",
        name: accounts[0].name || "Blake Brown",
      });
      responseStatus = "Success!";
    } catch {
      responseStatus = "Failed!";
    }
    setExportingCSS(false);
    setExportCSSStatus(responseStatus);
  };

  // Set an active class for 1.5 seconds so that we can apply some css to have a cool animation of a checkbox
  useEffect(() => {
    const timerId = setInterval(() => {
      setExportFigmaStatus("Export To Figma");
    }, 1500);

    return () => {
      clearInterval(timerId);
    };
  }, [exportFigmaStatus]);

  // Set an active class for 1.5 seconds so that we can apply some css to have a cool animation of a checkbox
  useEffect(() => {
    const timerId = setInterval(() => {
      setExportCSSStatus("Export To CSS");
    }, 1500);

    return () => {
      clearInterval(timerId);
    };
  }, [exportCSSStatus]);

  function exportButtonBackgroundColor(status) {
    if (status === "Success!") {
      return "Green";
    } else if (status === "Failed!") {
      return "Red";
    } else {
      return "rgb(26, 61, 134)";
    }
  }

  return (
    <div className="tertiary header">
      <div className="left-header-container">
        <button
          className="header-link-item"
          onClick={() => updateCurrentSet(DEFAULT_STATE.Color, true)}>
          Reset
        </button>
        <Link to={`/themeeditor/${clientid}/color/`} className="header-link-item">
          Change Set
        </Link>
      </div>
      <div className="middle-header-container">{paletteName}</div>
      <div className="right-header-container">
        <button
          className="header-link-item"
          onClick={(e) => handleFigmaExport(e)}
          style={{
            minWidth: 250,
            backgroundColor: exportButtonBackgroundColor(exportFigmaStatus),
          }}>
          {exportingFigma ? "Exporting..." : exportFigmaStatus}
        </button>
        <button
          className="header-link-item"
          onClick={(e) => handleCSSExport(e)}
          style={{ minWidth: 250, backgroundColor: exportButtonBackgroundColor(exportCSSStatus) }}>
          {exportingCSS ? "Exporting..." : exportCSSStatus}
        </button>
      </div>
    </div>
  );
};

export default ColorAppHeader;
